import data from "./MainDashboardData";
import moment from "moment";
import StatCard from "@/components/StatCard/StatCard";
import VisitStatCard from "@/components/VisitStatCard/VisitStatCard";
import StatTable from "@/components/StatTable/StatTable";
import Chart from "chart.js";
import randomMC from "random-material-color";
import jexcel from "jexcel";
import { mapState } from "vuex";

export default {
  ...data,
  components: {
    StatCard,
    VisitStatCard,
    StatTable,
  },
  props: {
    reportDates: Array,
    selectedBranch: Array,
    selectedDatasets: Array,
    selectedAreas: Array,
    selectedCustCat: Array,
    selectedCustGroup: Array,
    //tabledata: Array,
  },
  computed: {
    ...mapState("userProfileVuex", [
      "username",
      "useremail",
      "userImage",
      "datasets",
      "areas",
      "custgroups",
      "nkagroups",
      "custs",
      "prods",
      "branches",
      "roles",
    ]),
    reportMths() {
      let reportMths = [];

      let lastYearBegin = moment(new Date()) //limited to 1 previous year from today
        .subtract(1, "year")
        .startOf("year")
        .format("YYYY-MM-DD");

      for (let i = 0; i <= 24; i++) {
        let dateRange = [];
        let monthYearName = moment(lastYearBegin)
          .add(i, "month")
          .startOf("month")
          .format("MMM-YY");
        let dateFrom = moment(lastYearBegin)
          .add(i, "month")
          .startOf("month")
          .format("YYYY-MM-DD");
        let dateTo = moment(lastYearBegin)
          .add(i, "month")
          .endOf("month")
          .format("YYYY-MM-DD");
        let monthName = moment(lastYearBegin)
          .add(i, "month")
          .startOf("month")
          .format("MMM");
        dateRange.push(monthYearName, dateFrom, dateTo, monthName);
        reportMths.push(dateRange);
      }
      return reportMths;
    },
    previousDateFrom() {
      return moment(this.reportDates[0])
        .subtract(1, "month")
        .format("YYYY-MM-DD");
    },
    previousDateTo() {
      return moment(this.reportDates[1])
        .subtract(1, "month")
        .format("YYYY-MM-DD");
    },
    previousMonthDateFrom() {
      return moment(this.reportDates[0])
        .subtract(1, "month")
        .startOf("month")
        .format("YYYY-MM-DD");
    },
    previousMonthDateTo() {
      return moment(this.reportDates[0])
        .subtract(1, "month")
        .endOf("month")
        .format("YYYY-MM-DD");
    },
    currDays() {
      return moment(this.reportDates[1]).diff(
        moment(this.reportDates[0]),
        "days"
      );
    },
    toMthEndDays() {
      return moment(this.reportDates[0]).daysInMonth();
    },
  },
  methods: {
    getSpreadsheet(filter) {
      //console.log(data);
      this.spreadsheetData = [];
      let filteredData = [];

      document.getElementById("my-spreadsheet").innerHTML = "";
      //console.log(filter);

      if (filter) {
        filter.forEach((item) => {
          filteredData.push(
            ...this.monthTableRawData.filter((i) => i.name === item.name)
          );
        });
      } else {
        filteredData = this.monthTableRawData;
      }

      filteredData.forEach((item) => {
        this.spreadsheetData.push(
          [
            item.name,
            "prev",
            parseFloat(item[this.reportMths[0][0]]).toFixed(3),
            parseFloat(item[this.reportMths[1][0]]).toFixed(3),
            parseFloat(item[this.reportMths[2][0]]).toFixed(3),
            parseFloat(item[this.reportMths[3][0]]).toFixed(3),
            parseFloat(item[this.reportMths[4][0]]).toFixed(3),
            parseFloat(item[this.reportMths[5][0]]).toFixed(3),
            parseFloat(item[this.reportMths[6][0]]).toFixed(3),
            parseFloat(item[this.reportMths[7][0]]).toFixed(3),
            parseFloat(item[this.reportMths[8][0]]).toFixed(3),
            parseFloat(item[this.reportMths[9][0]]).toFixed(3),
            parseFloat(item[this.reportMths[10][0]]).toFixed(3),
            parseFloat(item[this.reportMths[11][0]]).toFixed(3),
          ],
          [
            item.name,
            "curr",
            parseFloat(item[this.reportMths[12][0]]).toFixed(3),
            parseFloat(item[this.reportMths[13][0]]).toFixed(3),
            parseFloat(item[this.reportMths[14][0]]).toFixed(3),
            parseFloat(item[this.reportMths[15][0]]).toFixed(3),
            parseFloat(item[this.reportMths[16][0]]).toFixed(3),
            parseFloat(item[this.reportMths[17][0]]).toFixed(3),
            parseFloat(item[this.reportMths[18][0]]).toFixed(3),
            parseFloat(item[this.reportMths[19][0]]).toFixed(3),
            parseFloat(item[this.reportMths[20][0]]).toFixed(3),
            parseFloat(item[this.reportMths[21][0]]).toFixed(3),
            parseFloat(item[this.reportMths[22][0]]).toFixed(3),
            parseFloat(item[this.reportMths[23][0]]).toFixed(3),
          ],
          [
            item.name,
            "diff",
            parseFloat(
              item[this.reportMths[12][0]] - item[this.reportMths[0][0]]
            ).toFixed(3),
            parseFloat(
              item[this.reportMths[13][0]] - item[this.reportMths[1][0]]
            ).toFixed(3),
            parseFloat(
              item[this.reportMths[14][0]] - item[this.reportMths[2][0]]
            ).toFixed(3),
            parseFloat(
              item[this.reportMths[15][0]] - item[this.reportMths[3][0]]
            ).toFixed(3),
            parseFloat(
              item[this.reportMths[16][0]] - item[this.reportMths[4][0]]
            ).toFixed(3),
            parseFloat(
              item[this.reportMths[17][0]] - item[this.reportMths[5][0]]
            ).toFixed(3),
            parseFloat(
              item[this.reportMths[18][0]] - item[this.reportMths[6][0]]
            ).toFixed(3),
            parseFloat(
              item[this.reportMths[19][0]] - item[this.reportMths[7][0]]
            ).toFixed(3),
            parseFloat(
              item[this.reportMths[20][0]] - item[this.reportMths[8][0]]
            ).toFixed(3),
            parseFloat(
              item[this.reportMths[21][0]] - item[this.reportMths[9][0]]
            ).toFixed(3),
            parseFloat(
              item[this.reportMths[22][0]] - item[this.reportMths[10][0]]
            ).toFixed(3),
            parseFloat(
              item[this.reportMths[23][0]] - item[this.reportMths[11][0]]
            ).toFixed(3),
          ],
          [
            item.name,
            "diff %",
            parseFloat(
              ((item[this.reportMths[12][0]] - item[this.reportMths[0][0]]) /
                item[this.reportMths[0][0]]) *
                100
            ).toFixed(1),
            parseFloat(
              ((item[this.reportMths[13][0]] - item[this.reportMths[1][0]]) /
                item[this.reportMths[1][0]]) *
                100
            ).toFixed(1),
            parseFloat(
              ((item[this.reportMths[14][0]] - item[this.reportMths[2][0]]) /
                item[this.reportMths[2][0]]) *
                100
            ).toFixed(1),
            parseFloat(
              ((item[this.reportMths[15][0]] - item[this.reportMths[3][0]]) /
                item[this.reportMths[3][0]]) *
                100
            ).toFixed(1),
            parseFloat(
              ((item[this.reportMths[16][0]] - item[this.reportMths[4][0]]) /
                item[this.reportMths[4][0]]) *
                100
            ).toFixed(1),
            parseFloat(
              ((item[this.reportMths[17][0]] - item[this.reportMths[5][0]]) /
                item[this.reportMths[5][0]]) *
                100
            ).toFixed(1),
            parseFloat(
              ((item[this.reportMths[18][0]] - item[this.reportMths[6][0]]) /
                item[this.reportMths[6][0]]) *
                100
            ).toFixed(1),
            parseFloat(
              ((item[this.reportMths[19][0]] - item[this.reportMths[7][0]]) /
                item[this.reportMths[7][0]]) *
                100
            ).toFixed(1),
            parseFloat(
              ((item[this.reportMths[20][0]] - item[this.reportMths[8][0]]) /
                item[this.reportMths[8][0]]) *
                100
            ).toFixed(1),
            parseFloat(
              ((item[this.reportMths[21][0]] - item[this.reportMths[9][0]]) /
                item[this.reportMths[9][0]]) *
                100
            ).toFixed(1),
            parseFloat(
              ((item[this.reportMths[22][0]] - item[this.reportMths[10][0]]) /
                item[this.reportMths[10][0]]) *
                100
            ).toFixed(1),
            parseFloat(
              item[this.reportMths[23][0]] -
                (item[this.reportMths[11][0]] / item[this.reportMths[11][0]]) *
                  100
            ).toFixed(1),
          ]
        );
      });
      //console.log(this.spreadsheetData);
      this.renderTable();
    },
    renderTable() {
      let table1 = jexcel(document.getElementById("my-spreadsheet"), {
        data: this.spreadsheetData,
        tableOverflow: true,
        lazyLoading: true,
        loadingSpin: true,
        columns: [
          {
            title: "Item",
            width: "100",
            align: "left",
          },
          { title: " ", width: "50", align: "right" },
          {
            title: "Jan",
            width: "60",
            align: "right",
          },
          { title: "Feb", width: "50", align: "right" },
          {
            title: "Mar",
            width: "60",
            align: "right",
          },
          { title: "Apr", width: "60", align: "right" },
          { title: "May", width: "60", align: "right" },
          { title: "Jun", width: "60", align: "right" },
          { title: "Jul", width: "60", align: "right" },
          { title: "Aug", width: "60", align: "right" },
          { title: "Sep", width: "60", align: "right" },
          { title: "Oct", width: "60", align: "right" },
          { title: "Nov", width: "60", align: "right" },
          { title: "Dec", width: "60", align: "right" },
        ],
        updateTable: function(instance, cell, col, row, val, label, cellName) {
          //console.log(cell);
          if (col === 0) {
            cell.style.fontWeight = "bold";
            cell.style.fontSize = "small";
          }
          if (col === 1) {
            cell.style.fontStyle = "italic";
            cell.style.fontSize = "small";
          }
          if (col > 1) {
            cell.style.fontSize = "small";
          }
        },
      });

      for (let i = 0; i < this.spreadsheetData.length; i += 4) {
        if (i % 2 === 0) {
          table1.setMerge(`A${i + 1}`, 0, 4);
        }
      }
    },
    getVisitsData() {
      let querydataset = "";

      this.selectedDatasets.forEach((item, index) => {
        if (index < this.selectedDatasets.length - 1) {
          querydataset += `SELECT *, "${this.selectedBranch[index]}" FROM ${item}.actualvisitsv2_temp UNION ALL SELECT *, "${this.selectedBranch[index]}" FROM ${item}.actualvisitsv2_${this.selectedBranch[index]} UNION ALL `;
        } else if (index === this.selectedDatasets.length - 1) {
          querydataset += `SELECT *, "${this.selectedBranch[index]}" FROM ${item}.actualvisitsv2_temp UNION ALL SELECT *, "${this.selectedBranch[index]}" FROM ${item}.actualvisitsv2_${this.selectedBranch[index]} `;
        }
      });

      let areas = "";
      if (this.selectedAreas.length === 0) {
        areas = this.areas;
      } else {
        areas = " AND area IN (";
        this.selectedAreas.forEach((i, index) => {
          if (index < this.selectedAreas.length - 1) {
            areas += `"${i}",`;
          } else {
            areas += `"${i}")`;
          }
        });
      }

      gapi.client.load("bigquery", "v2").then(() => {
        let sqlquery = `
        WITH querydataset AS (
          ${querydataset}
        )
          SELECT * 
          FROM querydataset
          WHERE created >= "${this.reportDates[0]}" AND created <="${this.reportDates[1]}"
          ${areas}
        `;

        let request = gapi.client.bigquery.jobs.query({
          projectId: "1082735422951",
          timeoutMs: "50000",
          query: sqlquery,
          useLegacySql: false,
        });

        request.execute((response) => {
          this.currVisit = parseFloat(response.rows.length).toFixed(0);
          this.prevVisit = parseFloat(0).toFixed(0);
          this.prevMthVisit = parseFloat(0).toFixed(0);
          this.projectedVisit = parseFloat(
            (response.rows.length / this.currDays) * this.toMthEndDays + 1
          ).toFixed(0);
          this.visitPerDay = parseFloat(
            response.rows.length / this.currDays
          ).toFixed(0);

          this.actualVisitsData = response.rows;
          this.getPlanVisitsData();
        });
      });
    },
    getPlanVisitsData() {
      let querydataset = "";
      this.selectedDatasets.forEach((item, index) => {
        if (index < this.selectedDatasets.length - 1) {
          querydataset += `SELECT *, "${this.selectedBranch[index]}" FROM ${item}.planvisitsv2_temp UNION ALL SELECT *, "${this.selectedBranch[index]}" FROM ${item}.planvisitsv2_${this.selectedBranch[index]} UNION ALL `;
        } else if (index === this.selectedDatasets.length - 1) {
          querydataset += `SELECT *, "${this.selectedBranch[index]}" FROM ${item}.planvisitsv2_temp UNION ALL SELECT *, "${this.selectedBranch[index]}" FROM ${item}.planvisitsv2_${this.selectedBranch[index]} `;
        }
      });

      let areas = "";
      if (this.selectedAreas.length === 0) {
        areas = this.areas;
      } else {
        areas = " AND area IN (";
        this.selectedAreas.forEach((i, index) => {
          if (index < this.selectedAreas.length - 1) {
            areas += `"${i}",`;
          } else {
            areas += `"${i}")`;
          }
        });
      }

      gapi.client.load("bigquery", "v2").then(() => {
        let sqlquery = `
        WITH querydataset AS (
          ${querydataset}
        )
            SELECT * 
            FROM querydataset
            WHERE month >= "${this.reportDates[0]}" AND month <="${this.reportDates[1]}"
            ${areas}
          `;

        let request = gapi.client.bigquery.jobs.query({
          projectId: "1082735422951",
          timeoutMs: "50000",
          query: sqlquery,
          useLegacySql: false,
        });

        let visitfactor = 0;
        if (this.selectedBranch.length === 1) {
          switch (this.selectedBranch[0]) {
            case "kl":
              visitfactor = 4.8;
              break;
            case "aor":
              visitfactor = 4;
              break;
            case "prai":
              visitfactor = 1;
              break;
            case "ipoh":
              visitfactor = 4.4;
              break;
            case "seremban":
              visitfactor = 2;
              break;
            case "jb":
              visitfactor = 3;
              break;
            case "kuantan":
              visitfactor = 2;
              break;
          }
        } else {
          visitfactor = 3.5;
        }

        request.execute((response) => {
          this.planVisit = parseFloat(
            response.rows.length * visitfactor
          ).toFixed(0); //TODO for other branches
          //this.planVisit = parseFloat(response.rows.length).toFixed(0);

          this.planVisitsData = response.rows;

          this.getTableData();
          this.getChartData();
        });
      });
    },
    getStatCardsData() {
      let querydataset = "";
      this.selectedDatasets.forEach((item, index) => {
        if (index < this.selectedDatasets.length - 1) {
          querydataset += `SELECT *, "${this.selectedBranch[index]}" FROM ${item}.trans_${this.selectedBranch[index]} UNION ALL `;
        } else if (index === this.selectedDatasets.length - 1) {
          querydataset += `SELECT *, "${this.selectedBranch[index]}" FROM ${item}.trans_${this.selectedBranch[index]} `;
        }
      });

      let areas = "";
      if (this.selectedAreas.length === 0) {
        areas = this.areas;
      } else {
        areas = " AND area IN (";
        this.selectedAreas.forEach((i, index) => {
          if (index < this.selectedAreas.length - 1) {
            areas += `"${i}",`;
          } else {
            areas += `"${i}")`;
          }
        });
      }

      let custgroup = "";
      if (this.selectedCustCat.length !== 0) {
        custgroup = " AND custgroupcat IN (";
        this.selectedCustCat.forEach((i, index) => {
          if (index < this.selectedCustCat.length - 1) {
            custgroup += `"${i}",`;
          } else {
            custgroup += `"${i}")`;
          }
        });
      }

      let custgroupname = "";
      if (this.selectedCustGroup.length !== 0) {
        custgroupname = " AND custgroup IN (";
        this.selectedCustGroup.forEach((i, index) => {
          if (index < this.selectedCustGroup.length - 1) {
            custgroupname += `"${i}",`;
          } else {
            custgroupname += `"${i}")`;
          }
        });
      }

      gapi.client.load("bigquery", "v2").then(() => {
        let sqlquery = `
        WITH querydataset AS (
          ${querydataset}
        )

        SELECT SUM(currmt) AS currmt, SUM(prevmt) AS prevmt, SUM(prevmthmt) AS prevmthmt,
        SUM(curramt) AS curramt, SUM(prevamt) AS prevamt, SUM(prevmthamt) AS prevmthamt
        FROM
        (SELECT
        CASE WHEN docdate >= "${this.reportDates[0]}" AND docdate <="${this.reportDates[1]}"
          THEN SUM(mt) ELSE 0 END AS currmt,
        CASE WHEN docdate >= "${this.previousDateFrom}" AND docdate <="${this.previousDateTo}"
          THEN SUM(mt) ELSE 0 END AS prevmt, 
        CASE WHEN docdate >= "${this.previousMonthDateFrom}" AND docdate <="${this.previousMonthDateTo}"
          THEN SUM(mt) ELSE 0 END AS prevmthmt,  
        CASE WHEN docdate >= "${this.reportDates[0]}" AND docdate <="${this.reportDates[1]}"
            THEN SUM(amount) ELSE 0 END AS curramt,
        CASE WHEN docdate >= "${this.previousDateFrom}" AND docdate <="${this.previousDateTo}"
            THEN SUM(amount) ELSE 0 END AS prevamt, 
        CASE WHEN docdate >= "${this.previousMonthDateFrom}" AND docdate <="${this.previousMonthDateTo}"
            THEN SUM(amount) ELSE 0 END AS prevmthamt
        FROM querydataset
        WHERE docdate >= "${this.previousMonthDateFrom}" AND docdate <= "${this.reportDates[1]}"
        ${areas}
        ${custgroup}
        ${custgroupname}
        ${this.custgroups}
        ${this.nkagroups}
        GROUP BY docdate)
        `;

        let request = gapi.client.bigquery.jobs.query({
          projectId: "1082735422951",
          timeoutMs: "50000",
          query: sqlquery,
          useLegacySql: false,
        });

        request.execute((response) => {
          this.currMT = parseFloat(response.rows[0].f[0].v).toFixed(3);
          this.prevMT = parseFloat(response.rows[0].f[1].v).toFixed(3);
          this.prevMthMT = parseFloat(response.rows[0].f[2].v).toFixed(3);
          this.projectedMT = parseFloat(
            (this.currMT / this.currDays) * this.toMthEndDays + 1
          ).toFixed(3);

          this.currAMT = parseFloat(response.rows[0].f[3].v).toFixed(0);
          //.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
          this.prevAMT = parseFloat(response.rows[0].f[4].v).toFixed(0);
          this.prevMthAMT = parseFloat(response.rows[0].f[5].v).toFixed(0);
          this.projectedAMT = parseFloat(
            (this.currAMT / this.currDays) * this.toMthEndDays + 1
          ).toFixed(0);
        });
      });
    },
    getTableData() {
      this.$swal("Fetching Data...........");
      this.$swal.showLoading();
      let querydataset = "";
      this.selectedDatasets.forEach((item, index) => {
        if (index < this.selectedDatasets.length - 1) {
          querydataset += `SELECT *, "${this.selectedBranch[index]}" FROM ${item}.trans_${this.selectedBranch[index]} UNION ALL `;
        } else if (index === this.selectedDatasets.length - 1) {
          querydataset += `SELECT *, "${this.selectedBranch[index]}" FROM ${item}.trans_${this.selectedBranch[index]} `;
        }
      });

      let areas = "";
      if (this.selectedAreas.length === 0) {
        areas = this.areas;
      } else {
        areas = " AND area IN (";
        this.selectedAreas.forEach((i, index) => {
          if (index < this.selectedAreas.length - 1) {
            areas += `"${i}",`;
          } else {
            areas += `"${i}")`;
          }
        });
      }

      let custgroup = "";
      if (this.selectedCustCat.length !== 0) {
        custgroup = " AND custgroupcat IN (";
        this.selectedCustCat.forEach((i, index) => {
          if (index < this.selectedCustCat.length - 1) {
            custgroup += `"${i}",`;
          } else {
            custgroup += `"${i}")`;
          }
        });
      }

      let custgroupname = "";
      if (this.selectedCustGroup.length !== 0) {
        custgroupname = " AND custgroup IN (";
        this.selectedCustGroup.forEach((i, index) => {
          if (index < this.selectedCustGroup.length - 1) {
            custgroupname += `"${i}",`;
          } else {
            custgroupname += `"${i}")`;
          }
        });
      }

      gapi.client.load("bigquery", "v2").then(() => {
        let sqlquery = `
        WITH querydataset AS (
          ${querydataset}
        )

        SELECT CASE WHEN custgroupcat IS NULL THEN "Uncategorised" ELSE custgroupcat END AS custcat, 
          custgroup, nkagroup, prodgroupcat AS category, brand, uom,  area,  
          CASE WHEN docdate >= "${this.reportDates[0]}" 
            AND docdate <= "${this.reportDates[1]}" THEN SUM(amount) ELSE 0 END AS amt1, 
          CASE WHEN docdate >= "${this.reportDates[0]}" 
            AND docdate <= "${this.reportDates[1]}" THEN SUM(mt) ELSE 0 END AS mt1
          FROM querydataset
          WHERE 
            docdate >= "${this.reportDates[0]}" AND docdate <= "${this.reportDates[1]}" 
            ${areas}
            ${custgroup}
            ${custgroupname}
            ${this.custgroups}
            ${this.nkagroups}
          GROUP BY custcat, custgroup, nkagroup, category, brand, uom,  area,  docdate`;

        let request = gapi.client.bigquery.jobs.query({
          projectId: "1082735422951",
          timeoutMs: "50000",
          query: sqlquery,
          useLegacySql: false,
        });

        request.execute((response) => {
          this.resultTotalRows = parseInt(response.totalRows);
          this.dataArray = [];
          this.checkRows(response.rows, response);
          //this.prepTableData(response.rows, response);
        });
      });
    },
    checkRows(rows, response) {
      rows.forEach((item) => {
        this.dataArray.push(item);
      });
      if (this.resultTotalRows > this.dataArray.length) {
        let jobref = response.jobReference;
        jobref.pageToken = response.pageToken;
        this.fetchBalTableRows(jobref);
      } else {
        this.prepTableData(this.dataArray);
      }
    },
    prepTableData(rawdata) {
      this.tabledata = [];

      this.tableDimensionData.forEach((item) => {
        let dataString = [];
        let total1 = 0;
        let total2 = 0;

        if (item.name !== "Visits") {
          let data = [];
          rawdata.forEach((row) => {
            let rowIndex = data.findIndex(
              (i) => i.name === row.f[item.dataIndex].v
            );
            total1 += parseFloat(row.f[8].v);
            total2 += parseFloat(row.f[7].v);

            if (rowIndex === -1) {
              data.push({
                name: row.f[item.dataIndex].v,
                mt: parseFloat(row.f[8].v),
                amt: parseFloat(row.f[7].v),
              });
            } else {
              data[rowIndex].mt += parseFloat(row.f[8].v);
              data[rowIndex].amt += parseFloat(row.f[7].v);
            }
          });

          data.forEach((line) => {
            dataString.push({
              name: line.name,
              mt: parseFloat(line.mt).toFixed(3),
              amt: parseFloat(line.amt).toFixed(2),
            });
          });
          this[item.total1] = parseFloat(total1).toFixed(3);
          this[item.total2] = parseFloat(total2).toFixed(3);

          this.tabledata.push({
            name: item.name,
            data: dataString,
            tabletype: "mt",
            total1: parseFloat(total1).toFixed(3),
            total2: parseFloat(total2).toFixed(3),
          });

          this.$swal.close();
        } else if (item.name === "Visits") {
          let actualvisitdata = [];
          let planvisitdata = [];

          this.planVisitsData.forEach((row) => {
            let planrowIndex = planvisitdata.findIndex(
              (i) => i.name === row.f[0].v
            );

            if (planrowIndex === -1) {
              planvisitdata.push({
                name: row.f[0].v,
                planvisits: 1,
              });
            } else {
              planvisitdata[planrowIndex].planvisits += 1;
            }
          });

          this.actualVisitsData.forEach((row) => {
            let rowIndex = actualvisitdata.findIndex(
              (i) => i.name === row.f[1].v
            );
            total1 += 1;
            total2 += 1;

            if (rowIndex === -1) {
              actualvisitdata.push({
                name: row.f[1].v,
                mt: 1,
              });
            } else {
              actualvisitdata[rowIndex].mt += 1;
            }
          });

          actualvisitdata.forEach((line) => {
            let lineplanvisits = planvisitdata.find(
              (i) => i.name === line.name
            );
            let totalplanvisits = lineplanvisits
              ? lineplanvisits.planvisits * 4 //TODO other branches
              : line.mt;

            dataString.push({
              name: line.name,
              mt: parseFloat(line.mt).toFixed(0),
              amt:
                parseFloat((line.mt / totalplanvisits) * 100).toFixed(1) + "%",
            });
          });
          this[item.total1] = parseFloat(total1).toFixed(0);
          this[item.total2] = parseFloat(
            (this.currVisit / this.planVisit) * 100
          ).toFixed(1);

          this.tabledata.push({
            name: item.name,
            data: dataString,
            tabletype: "visit",
            total1: parseFloat(total1).toFixed(0),
            total2:
              parseFloat((this.currVisit / this.planVisit) * 100).toFixed(1) +
              "%",
          });

          this.$swal.close();
        }
      });
    },
    fetchBalTableRows(jobref) {
      let request = gapi.client.bigquery.jobs.getQueryResults(jobref);

      request.execute((response) => {
        //back to process results and append to resultsArray
        this.checkRows(response.rows, response);
      });
    },
    getChartData() {
      let querydataset = "";
      this.selectedDatasets.forEach((item, index) => {
        if (index < this.selectedDatasets.length - 1) {
          querydataset += `SELECT *, "${this.selectedBranch[index]}" FROM ${item}.trans_${this.selectedBranch[index]} UNION ALL `;
        } else if (index === this.selectedDatasets.length - 1) {
          querydataset += `SELECT *, "${this.selectedBranch[index]}" FROM ${item}.trans_${this.selectedBranch[index]} `;
        }
      });

      let areas = "";
      if (this.selectedAreas.length === 0) {
        areas = this.areas;
      } else {
        areas = " AND area IN (";
        this.selectedAreas.forEach((i, index) => {
          if (index < this.selectedAreas.length - 1) {
            areas += `"${i}",`;
          } else {
            areas += `"${i}")`;
          }
        });
      }

      let custgroup = "";
      if (this.selectedCustCat.length !== 0) {
        custgroup = " AND custgroupcat IN (";
        this.selectedCustCat.forEach((i, index) => {
          if (index < this.selectedCustCat.length - 1) {
            custgroup += `"${i}",`;
          } else {
            custgroup += `"${i}")`;
          }
        });
      }

      gapi.client.load("bigquery", "v2").then(() => {
        let sqlquery = `
        WITH querydataset AS (
          ${querydataset}
        )

        SELECT SUM(mt0) AS mt0, SUM(mt1) AS mt1, SUM(mt2) AS mt2, SUM(mt3) AS mt3,
        SUM(mt4) AS mt4, SUM(mt5) AS mt5, SUM(mt6) AS mt6,SUM(mt7) AS mt7,SUM(mt8) AS mt8,
        SUM(mt9) AS mt9,SUM(mt10) AS mt10,SUM(mt11) AS mt11,SUM(mt12) AS mt12, SUM(mt13) AS mt13,
        SUM(mt14) AS mt14,SUM(mt15) AS mt15,SUM(mt16) AS mt16, SUM(mt17) AS mt17,
        SUM(mt18) AS mt18, SUM(mt19) AS mt19, SUM(mt20) AS mt20, SUM(mt21) AS mt21,
        SUM(mt22) AS mt22, SUM(mt23) AS mt23, SUM(mt24) AS mt24,
        custcat,category, custgroup, brand,area
        FROM
        (SELECT CASE WHEN custgroupcat IS NULL THEN "Uncategorised" ELSE custgroupcat END AS custcat, 
          prodgroupcat AS category, custgroup, brand,area,
          CASE WHEN docdate >= "${this.reportMths[0][1]}" 
            AND docdate <= "${this.reportMths[0][2]}" THEN SUM(mt) ELSE 0 END AS mt0, 
          CASE WHEN docdate >= "${this.reportMths[1][1]}" 
            AND docdate <= "${this.reportMths[1][2]}" THEN SUM(mt) ELSE 0 END AS mt1, 
          CASE WHEN docdate >= "${this.reportMths[2][1]}" 
            AND docdate <= "${this.reportMths[2][2]}" THEN SUM(mt) ELSE 0 END AS mt2, 
          CASE WHEN docdate >= "${this.reportMths[3][1]}" 
            AND docdate <= "${this.reportMths[3][2]}" THEN SUM(mt) ELSE 0 END AS mt3, 
          CASE WHEN docdate >= "${this.reportMths[4][1]}" 
            AND docdate <= "${this.reportMths[4][2]}" THEN SUM(mt) ELSE 0 END AS mt4, 
          CASE WHEN docdate >= "${this.reportMths[5][1]}" 
            AND docdate <= "${this.reportMths[5][2]}" THEN SUM(mt) ELSE 0 END AS mt5, 
          CASE WHEN docdate >= "${this.reportMths[6][1]}" 
            AND docdate <= "${this.reportMths[6][2]}" THEN SUM(mt) ELSE 0 END AS mt6, 
          CASE WHEN docdate >= "${this.reportMths[7][1]}" 
            AND docdate <= "${this.reportMths[7][2]}" THEN SUM(mt) ELSE 0 END AS mt7, 
          CASE WHEN docdate >= "${this.reportMths[8][1]}" 
            AND docdate <= "${this.reportMths[8][2]}" THEN SUM(mt) ELSE 0 END AS mt8, 
          CASE WHEN docdate >= "${this.reportMths[9][1]}" 
            AND docdate <= "${this.reportMths[9][2]}" THEN SUM(mt) ELSE 0 END AS mt9, 
          CASE WHEN docdate >= "${this.reportMths[10][1]}" 
            AND docdate <= "${this.reportMths[10][2]}" THEN SUM(mt) ELSE 0 END AS mt10,
          CASE WHEN docdate >= "${this.reportMths[11][1]}" 
            AND docdate <= "${this.reportMths[11][2]}" THEN SUM(mt) ELSE 0 END AS mt11,
          CASE WHEN docdate >= "${this.reportMths[12][1]}" 
            AND docdate <= "${this.reportMths[12][2]}" THEN SUM(mt) ELSE 0 END AS mt12,
          CASE WHEN docdate >= "${this.reportMths[13][1]}" 
            AND docdate <= "${this.reportMths[13][2]}" THEN SUM(mt) ELSE 0 END AS mt13,
          CASE WHEN docdate >= "${this.reportMths[14][1]}" 
            AND docdate <= "${this.reportMths[14][2]}" THEN SUM(mt) ELSE 0 END AS mt14,
          CASE WHEN docdate >= "${this.reportMths[15][1]}" 
            AND docdate <= "${this.reportMths[15][2]}" THEN SUM(mt) ELSE 0 END AS mt15,
          CASE WHEN docdate >= "${this.reportMths[16][1]}" 
            AND docdate <= "${this.reportMths[16][2]}" THEN SUM(mt) ELSE 0 END AS mt16,
          CASE WHEN docdate >= "${this.reportMths[17][1]}" 
            AND docdate <= "${this.reportMths[17][2]}" THEN SUM(mt) ELSE 0 END AS mt17,
          CASE WHEN docdate >= "${this.reportMths[18][1]}" 
            AND docdate <= "${this.reportMths[18][2]}" THEN SUM(mt) ELSE 0 END AS mt18,
          CASE WHEN docdate >= "${this.reportMths[19][1]}" 
            AND docdate <= "${this.reportMths[19][2]}" THEN SUM(mt) ELSE 0 END AS mt19,
          CASE WHEN docdate >= "${this.reportMths[20][1]}" 
            AND docdate <= "${this.reportMths[20][2]}" THEN SUM(mt) ELSE 0 END AS mt20,
          CASE WHEN docdate >= "${this.reportMths[21][1]}" 
            AND docdate <= "${this.reportMths[21][2]}" THEN SUM(mt) ELSE 0 END AS mt21,
          CASE WHEN docdate >= "${this.reportMths[22][1]}" 
            AND docdate <= "${this.reportMths[22][2]}" THEN SUM(mt) ELSE 0 END AS mt22,
          CASE WHEN docdate >= "${this.reportMths[23][1]}" 
            AND docdate <= "${this.reportMths[23][2]}" THEN SUM(mt) ELSE 0 END AS mt23,
          CASE WHEN docdate >= "${this.reportMths[24][1]}" 
            AND docdate <= "${this.reportMths[24][2]}" THEN SUM(mt) ELSE 0 END AS mt24   
          FROM querydataset
          WHERE true
          ${areas}
          ${custgroup}
          ${this.custgroups}
          ${this.nkagroups}
          GROUP BY custcat, custgroup, nkagroup, category, brand, uom,  area,  docdate)
          GROUP BY custcat, category, custgroup, brand,area`;

        let request = gapi.client.bigquery.jobs.query({
          projectId: "1082735422951",
          timeoutMs: "50000",
          query: sqlquery,
          useLegacySql: false,
        });

        request.execute((response) => {
          this.chartQueryResponse = response;
          this.prepProdCatLineChart();
        });
      });
    },
    selectedTab(e) {
      this.chartType = "bar";
      this.selectedTableDimension = this.tableDimensionData[e].schemaName;

      document.getElementById("my-spreadsheet").innerHTML = "";

      if (this.tabChange > 0) {
        if (this.tableDimensionData[e].name !== "Visits") {
          this.selectedTableDimensionName = this.tableDimensionData[e].name;
          this.prepProdCatLineChart();
          //jexcel.destroy(document.getElementById("my-spreadsheet"), true);
        }
      }
      this.tabChange++;
    },
    updateSelectedItem(e) {
      this.selectedTableItems = [];
      let line1data = [];
      let line2data = [];

      e.forEach((item) => {
        this.selectedTableItems.push(item.name);
        line1data.push(
          ...this.prodCatLineData2.filter((i) => i.name === item.name)
        );
        line2data.push(
          ...this.prodCatLineData1.filter((i) => i.name === item.name)
        );
      });

      this.drawChart(line1data, line2data);
      this.getSpreadsheet(e);
      //this.prep12MonthTable(this.monthTableRawData, e);
      //this.getSpreadsheet(this.monthTableRawData, e);
      //jexcel.destroy(document.getElementById("my-spreadsheet"), true);
    },
    prepProdCatLineChart() {
      let prodCat = [];

      /*if (this.selectedTableDimension === "") {
        this.selectedTableDimension = "area";
      }*/

      let schemaIndex = this.chartQueryResponse.schema.fields.findIndex(
        (i) => i.name === this.selectedTableDimension
      );

      this.chartQueryResponse.rows.forEach((row) => {
        let prodCatIndex = prodCat.findIndex(
          (i) => i.name === row.f[schemaIndex].v
        );

        if (prodCatIndex === -1) {
          prodCat.push({
            name: row.f[schemaIndex].v,
            [this.reportMths[0][0]]: parseFloat(row.f[0].v),
            [this.reportMths[1][0]]: parseFloat(row.f[1].v),
            [this.reportMths[2][0]]: parseFloat(row.f[2].v),
            [this.reportMths[3][0]]: parseFloat(row.f[3].v),
            [this.reportMths[4][0]]: parseFloat(row.f[4].v),
            [this.reportMths[5][0]]: parseFloat(row.f[5].v),
            [this.reportMths[6][0]]: parseFloat(row.f[6].v),
            [this.reportMths[7][0]]: parseFloat(row.f[7].v),
            [this.reportMths[8][0]]: parseFloat(row.f[8].v),
            [this.reportMths[9][0]]: parseFloat(row.f[9].v),
            [this.reportMths[10][0]]: parseFloat(row.f[10].v),
            [this.reportMths[11][0]]: parseFloat(row.f[11].v),
            [this.reportMths[12][0]]: parseFloat(row.f[12].v),
            [this.reportMths[13][0]]: parseFloat(row.f[13].v),
            [this.reportMths[14][0]]: parseFloat(row.f[14].v),
            [this.reportMths[15][0]]: parseFloat(row.f[15].v),
            [this.reportMths[16][0]]: parseFloat(row.f[16].v),
            [this.reportMths[17][0]]: parseFloat(row.f[17].v),
            [this.reportMths[18][0]]: parseFloat(row.f[18].v),
            [this.reportMths[19][0]]: parseFloat(row.f[19].v),
            [this.reportMths[20][0]]: parseFloat(row.f[20].v),
            [this.reportMths[21][0]]: parseFloat(row.f[21].v),
            [this.reportMths[22][0]]: parseFloat(row.f[22].v),
            [this.reportMths[23][0]]: parseFloat(row.f[23].v),
          });
        } else {
          prodCat[prodCatIndex][this.reportMths[0][0]] += parseFloat(
            row.f[0].v
          );
          prodCat[prodCatIndex][this.reportMths[1][0]] += parseFloat(
            row.f[1].v
          );
          prodCat[prodCatIndex][this.reportMths[2][0]] += parseFloat(
            row.f[2].v
          );
          prodCat[prodCatIndex][this.reportMths[3][0]] += parseFloat(
            row.f[3].v
          );
          prodCat[prodCatIndex][this.reportMths[4][0]] += parseFloat(
            row.f[4].v
          );
          prodCat[prodCatIndex][this.reportMths[5][0]] += parseFloat(
            row.f[5].v
          );
          prodCat[prodCatIndex][this.reportMths[6][0]] += parseFloat(
            row.f[6].v
          );
          prodCat[prodCatIndex][this.reportMths[7][0]] += parseFloat(
            row.f[7].v
          );
          prodCat[prodCatIndex][this.reportMths[8][0]] += parseFloat(
            row.f[8].v
          );
          prodCat[prodCatIndex][this.reportMths[9][0]] += parseFloat(
            row.f[9].v
          );
          prodCat[prodCatIndex][this.reportMths[10][0]] += parseFloat(
            row.f[10].v
          );
          prodCat[prodCatIndex][this.reportMths[11][0]] += parseFloat(
            row.f[11].v
          );
          prodCat[prodCatIndex][this.reportMths[12][0]] += parseFloat(
            row.f[12].v
          );
          prodCat[prodCatIndex][this.reportMths[13][0]] += parseFloat(
            row.f[13].v
          );
          prodCat[prodCatIndex][this.reportMths[14][0]] += parseFloat(
            row.f[14].v
          );
          prodCat[prodCatIndex][this.reportMths[15][0]] += parseFloat(
            row.f[15].v
          );
          prodCat[prodCatIndex][this.reportMths[16][0]] += parseFloat(
            row.f[16].v
          );
          prodCat[prodCatIndex][this.reportMths[17][0]] += parseFloat(
            row.f[17].v
          );
          prodCat[prodCatIndex][this.reportMths[18][0]] += parseFloat(
            row.f[18].v
          );
          prodCat[prodCatIndex][this.reportMths[19][0]] += parseFloat(
            row.f[19].v
          );
          prodCat[prodCatIndex][this.reportMths[20][0]] += parseFloat(
            row.f[20].v
          );
          prodCat[prodCatIndex][this.reportMths[21][0]] += parseFloat(
            row.f[21].v
          );
          prodCat[prodCatIndex][this.reportMths[22][0]] += parseFloat(
            row.f[22].v
          );
          prodCat[prodCatIndex][this.reportMths[23][0]] += parseFloat(
            row.f[23].v
          );
        }
      });

      this.monthTableRawData = prodCat;
      //this.prep12MonthTable(prodCat); //call prep 12  month table function
      //this.getSpreadsheet();

      this.prodCatLineLabels = [];
      this.reportMths.forEach((mth) => {
        this.prodCatLineLabels.push(mth[0]);
      });

      this.prodCatLineData = [];
      this.prodCatLineData1 = [];
      this.prodCatLineData2 = [];
      prodCat.forEach((item) => {
        let itemData1 = {
          name: item.name,
          label: item.name + " (prev)",
          data: [
            item[[this.reportMths[0][0]]].toFixed(3),
            item[[this.reportMths[1][0]]].toFixed(3),
            item[[this.reportMths[2][0]]].toFixed(3),
            item[[this.reportMths[3][0]]].toFixed(3),
            item[[this.reportMths[4][0]]].toFixed(3),
            item[[this.reportMths[5][0]]].toFixed(3),
            item[[this.reportMths[6][0]]].toFixed(3),
            item[[this.reportMths[7][0]]].toFixed(3),
            item[[this.reportMths[8][0]]].toFixed(3),
            item[[this.reportMths[9][0]]].toFixed(3),
            item[[this.reportMths[10][0]]].toFixed(3),
            item[[this.reportMths[11][0]]].toFixed(3),
          ],
          fill: false,
          pointRadius: 0,
          tension: 0,
          /*borderColor: ["#40C4FF"],
          backgroundColor: ["#40C4FF"],*/
          borderColor: ["#B0BEC5"],
          backgroundColor: [
            "#B0BEC5",
            "#B0BEC5",
            "#B0BEC5",
            "#B0BEC5",
            "#B0BEC5",
            "#B0BEC5",
            "#B0BEC5",
            "#B0BEC5",
            "#B0BEC5",
            "#B0BEC5",
            "#B0BEC5",
            "#B0BEC5",
          ],
        };

        let itemData2 = {
          name: item.name,
          label: item.name,
          data: [
            item[[this.reportMths[12][0]]].toFixed(3),
            item[[this.reportMths[13][0]]].toFixed(3),
            item[[this.reportMths[14][0]]].toFixed(3),
            item[[this.reportMths[15][0]]].toFixed(3),
            item[[this.reportMths[16][0]]].toFixed(3),
            item[[this.reportMths[17][0]]].toFixed(3),
            item[[this.reportMths[18][0]]].toFixed(3),
            item[[this.reportMths[19][0]]].toFixed(3),
            item[[this.reportMths[20][0]]].toFixed(3),
            item[[this.reportMths[21][0]]].toFixed(3),
            item[[this.reportMths[22][0]]].toFixed(3),
            item[[this.reportMths[23][0]]].toFixed(3),
          ],
          fill: false,
          pointRadius: 5,
          pointHitRadius: 15,
          pointHoverRadius: 10,
          tension: 0,
          borderColor: ["#40C4FF"],
          backgroundColor: [
            "#40C4FF",
            "#40C4FF",
            "#40C4FF",
            "#40C4FF",
            "#40C4FF",
            "#40C4FF",
            "#40C4FF",
            "#40C4FF",
            "#40C4FF",
            "#40C4FF",
            "#40C4FF",
            "#40C4FF",
          ],
          /*borderColor: [randomMC.getColor()],
          backgroundColor: [
            randomMC.getColor(),
            randomMC.getColor(),
            randomMC.getColor(),
            randomMC.getColor(),
            randomMC.getColor(),
            randomMC.getColor(),
            randomMC.getColor(),
            randomMC.getColor(),
            randomMC.getColor(),
            randomMC.getColor(),
            randomMC.getColor(),
            randomMC.getColor(),
          ],*/
        };

        this.prodCatLineData1.push(itemData1);

        this.prodCatLineData2.push(itemData2);
      });
      this.drawChart(this.prodCatLineData1, this.prodCatLineData2);
    },
    updateChartType() {
      console.log(this.chartType);
      let e = [];
      this.selectedTableItems.forEach((item) => {
        e.push({
          name: item,
        });
      });
      this.updateSelectedItem(e);
      if (this.chartType === "table") {
        this.getSpreadsheet();
      } /*else {
        this.prepProdCatLineChart();
      }*/
    },
    drawChart(line2data, line1data) {
      if (this.chartType !== "table") {
        document.getElementById("chart1").remove();

        let canvas = document.createElement("canvas");
        canvas.setAttribute("id", "chart1");
        canvas.setAttribute("width", "300");
        canvas.setAttribute("height", "130");
        document.getElementById("chartreport").appendChild(canvas);

        let ctx = document.getElementById("chart1").getContext("2d");
        let myChart = new Chart(ctx, {
          type: this.chartType,
          data: {
            labels: [
              "Jan",
              "Feb",
              "Mar",
              "Apr",
              "May",
              "Jun",
              "Jul",
              "Aug",
              "Sep",
              "Oct",
              "Nov",
              "Dec",
            ],
            datasets: [...line1data, ...line2data],
          },
          options: {
            scales: {
              yAxes: [
                {
                  ticks: {
                    beginAtZero: true,
                  },
                },
              ],
            },
            legend: {
              display: false,
              position: "bottom",
              fontSize: 6,
              boxWidth: 5,
              padding: 3,
              onClick: (e) => e.stopPropagation(),
            },
            events: ["click"],
          },
        });
        //document.getElementById("js-legend").innerHTML = myChart.generateLegend();
      }
    },
  },
  mounted() {
    this.getStatCardsData();
    this.getVisitsData();

    this.chartType = "bar";

    document.getElementById("my-spreadsheet").innerHTML = "";
  },
};
